import { ErrorService } from "../error/error.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { User, UserStatus } from "../data/user/user.model";
import { BehaviorSubject } from "rxjs";
import { AuthenticationStorage } from "./authentication-storage.service";
import { AuthenticationHttpService } from "./authentication-http.service";
import { LoaderService } from "../../services/loader/loader.service";

@Injectable()
export class AuthenticationService {
  public userStatus$: Observable<UserStatus>;
  public userUid$: Observable<any>;
  public currentUser$: Observable<any>;
  public errorState$: Observable<any>;

  private errorState: BehaviorSubject<any> = new BehaviorSubject(null);
  private userStatusSubject: BehaviorSubject<UserStatus> = new BehaviorSubject(
    UserStatus.unlogged
  );
  private userUidSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  private currentUserSubject: BehaviorSubject<User> = new BehaviorSubject(null);

  constructor(
    private authHttp: AuthenticationHttpService,
    private authStorage: AuthenticationStorage,
    private error: ErrorService,
    private loaderService: LoaderService // private userService: UserService
  ) {
    this.userStatus$ = this.userStatusSubject.asObservable();
    this.userUid$ = this.userUidSubject.asObservable();
    this.currentUser$ = this.currentUserSubject.asObservable();
    this.errorState$ = this.errorState.asObservable();

    this.authStorage
      .getUid()
      .then((uid) => {
        if (uid) {
          this.userStatusSubject.next(UserStatus.exists);
          this.userUidSubject.next(uid);
        } else {
          this.userStatusSubject.next(UserStatus.unlogged);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  login(username: string, password: string, status: string): Promise<any> {
    return this.authHttp
      .login(username, password, status)
      .catch((e) => {
        this.loaderService.stopLoader();
        this.error.addError("", e.error);
        return Observable.of(null);
      })
      .toPromise()
      .then((user: User) => {
        /**
         * Insert user login information inside the storage
         */
        if (user !== null) {
          this.authStorage.setToken(user.apiToken);
          this.authStorage.setRefreshToken(user.apiRefreshToken);
          this.authStorage.setTokenExpiration(user.apiTokenExpiration);
          this.authStorage.setUid(user._id), this.currentUserSubject.next(user);
          this.userStatusSubject.next(user.activeRoute || UserStatus.logged);
          this.userUidSubject.next(user._id);
        }

        return user;
      });
  }

  forceLogin(user: User, _route: string) {
    this.authStorage.setToken(user.apiToken);
    this.authStorage.setRefreshToken(user.apiRefreshToken);
    this.authStorage.setTokenExpiration(user.apiTokenExpiration);
    this.authStorage.setUid(user._id), this.currentUserSubject.next(user);
    this.userStatusSubject.next(user.activeRoute || UserStatus.logged);
    this.userUidSubject.next(user._id);
  }

  registration(
    phone: string,
    password: string,
    privacy: object,
    status: string
  ) {
    this.authHttp
      .registation(phone, password, privacy, status)
      .catch((e) => {
        this.error.addError("", e.error);
        return Observable.of(null);
      })
      .subscribe(async (user: User) => {
        if (user !== null) {
          await Promise.all([
            this.authStorage.setToken(user.apiToken),
            this.authStorage.setRefreshToken(user.apiRefreshToken),
            this.authStorage.setTokenExpiration(user.apiTokenExpiration),
            this.authStorage.setUid(user._id),
          ]);
          this.currentUserSubject.next(user);
          this.userStatusSubject.next(UserStatus.registered);
          this.userUidSubject.next(user._id);
        }
      });
  }

  checkVerificationCode(code: string) {
    this.authHttp
      .verificationCode(code)
      .catch((e) => {
        //this.error.addError('',e.error);
        console.error('ERROR checkVerificationCode', e);
        return Observable.of(null);
      })
      .subscribe((user: User) => {
        if (user !== null) {
          this.currentUserSubject.next(user);
          this.userStatusSubject.next(UserStatus.verified);
        }
      });
  }

  checkVerificationPasswordCode(code, phone) {
    this.authHttp
      .verificationPasswordCode(code, phone)
      .catch((e) => {
        console.error(e);
        return Observable.of(null);
      })
      .subscribe((user: User) => {
        if (user !== null) {
          // this.currentUserSubject.next(user);
          // this.userStatusSubject.next(UserStatus.verified);
          this.authStorage.setToken(user.apiToken);
          this.authStorage.setRefreshToken(user.apiRefreshToken);
          this.authStorage.setTokenExpiration(user.apiTokenExpiration);
          this.authStorage.setUid(user._id), this.currentUserSubject.next(user);
          this.userStatusSubject.next(user.activeRoute || UserStatus.logged);
          this.userUidSubject.next(user._id);
        }
      });
  }

  resendVerification() {
    this.authHttp
      .askToSendSMS()
      .catch((e) => {
        this.error.addError("", e.error);
        return Observable.of(null);
      })
      .subscribe((res) => {
        return true;
      });
  }

  recoverPassword(phone) {
    this.authHttp
      .askToSendSMSToRecover(phone)
      .catch((e) => {
        this.error.addError("", e.error);
        return Observable.of(null);
      })
      .subscribe((res) => {
        return true;
      });
  }

  updatePassword(id, password) {
    this.authHttp
      .newPassword(id, password)
      .catch((e) => {
        this.error.addError("", e.error);
        return Observable.of(null);
      })
      .subscribe((res) => {
        return true;
      });
  }

  updateUserStatus(status: UserStatus) {
    this.userStatusSubject.next(status);
  }

  updateCurrentUser(user: User) {
    this.currentUserSubject.next(user);
  }

  logOut() {
    //this.userService.updateUser({notificationToken: ''});
    //await this.userService.logout();
    this.authStorage.deleteAll();
    this.userStatusSubject.next(UserStatus.unlogged);
    this.currentUserSubject.next(null);
    //window.location.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/authentication/authentication.service.ts